/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { CLMFeature } from './clmfeature';
// May contain unused imports in some cases
// @ts-ignore
import type { CommitmentBudgetsFeature } from './commitment-budgets-feature';
// May contain unused imports in some cases
// @ts-ignore
import type { ConsolidationFeature } from './consolidation-feature';
// May contain unused imports in some cases
// @ts-ignore
import type { ContinuousRebalancingFeature } from './continuous-rebalancing-feature';
// May contain unused imports in some cases
// @ts-ignore
import type { PodMutationsFeature } from './pod-mutations-feature';
// May contain unused imports in some cases
// @ts-ignore
import type { RebalancingFeature } from './rebalancing-feature';
// May contain unused imports in some cases
// @ts-ignore
import type { SpotInterruptionPredictionFeature } from './spot-interruption-prediction-feature';
// May contain unused imports in some cases
// @ts-ignore
import type { WorkloadRightSizingFeature } from './workload-right-sizing-feature';

/**
 * Feature represents a KENT optimization feature.  Each feature type corresponds to a card in the UI mockup.
 * @export
 * @interface Feature
 */
export interface Feature {
    /**
     * Data for the Container Live Migration (CLM) feature.
     * @type {CLMFeature}
     * @memberof Feature
     */
    'clm'?: CLMFeature;
    /**
     * Data for the commitment budgets feature.
     * @type {CommitmentBudgetsFeature}
     * @memberof Feature
     */
    'commitmentBudgets'?: CommitmentBudgetsFeature;
    /**
     * Data for the consolidation feature.
     * @type {ConsolidationFeature}
     * @memberof Feature
     */
    'consolidation'?: ConsolidationFeature;
    /**
     * Data for the continuous rebalancing feature.
     * @type {ContinuousRebalancingFeature}
     * @memberof Feature
     */
    'continuousRebalancing'?: ContinuousRebalancingFeature;
    /**
     * Unique identifier for the feature.  Examples: consolidation, workload_right_sizing, spot_interruption_prediction,  rebalancing, pod_mutations.
     * @type {string}
     * @memberof Feature
     */
    'id'?: string;
    /**
     * Metrics status indicates if metrics are ready or still being generated.
     * @type {string}
     * @memberof Feature
     */
    'metricsStatus'?: FeatureMetricsStatusEnum;
    /**
     * Timestamp when the metrics were generated.
     * @type {string}
     * @memberof Feature
     */
    'metricsTime'?: string;
    /**
     * Data for the pod mutations feature.
     * @type {PodMutationsFeature}
     * @memberof Feature
     */
    'podMutations'?: PodMutationsFeature;
    /**
     * Data for the rebalancing feature.
     * @type {RebalancingFeature}
     * @memberof Feature
     */
    'rebalancing'?: RebalancingFeature;
    /**
     * Data for the spot interruption prediction feature.
     * @type {SpotInterruptionPredictionFeature}
     * @memberof Feature
     */
    'spotInterruptionPrediction'?: SpotInterruptionPredictionFeature;
    /**
     * Current state of the feature.
     * @type {string}
     * @memberof Feature
     */
    'status'?: FeatureStatusEnum;
    /**
     * Type of the feature (helper for the data field).
     * @type {string}
     * @memberof Feature
     */
    'type'?: FeatureTypeEnum;
    /**
     * Data for the workload right-sizing feature.
     * @type {WorkloadRightSizingFeature}
     * @memberof Feature
     */
    'workloadRightSizing'?: WorkloadRightSizingFeature;
}

export const FeatureMetricsStatusEnum = {
    METRICS_STATUS_UNSPECIFIED: 'METRICS_STATUS_UNSPECIFIED',
    READY: 'READY',
    GENERATING: 'GENERATING',
    ERROR: 'ERROR'
} as const;

export type FeatureMetricsStatusEnum = typeof FeatureMetricsStatusEnum[keyof typeof FeatureMetricsStatusEnum];
export const FeatureStatusEnum = {
    FEATURE_STATUS_UNSPECIFIED: 'FEATURE_STATUS_UNSPECIFIED',
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED',
    UNAVAILABLE: 'UNAVAILABLE'
} as const;

export type FeatureStatusEnum = typeof FeatureStatusEnum[keyof typeof FeatureStatusEnum];
export const FeatureTypeEnum = {
    FEATURE_TYPE_UNSPECIFIED: 'FEATURE_TYPE_UNSPECIFIED',
    CONSOLIDATION: 'CONSOLIDATION',
    WORKLOAD_RIGHT_SIZING: 'WORKLOAD_RIGHT_SIZING',
    SPOT_INTERRUPTION_PREDICTION: 'SPOT_INTERRUPTION_PREDICTION',
    REBALANCING: 'REBALANCING',
    POD_MUTATIONS: 'POD_MUTATIONS',
    CLM: 'CLM',
    CONTINUOUS_REBALANCING: 'CONTINUOUS_REBALANCING',
    COMMITMENT_BUDGETS: 'COMMITMENT_BUDGETS'
} as const;

export type FeatureTypeEnum = typeof FeatureTypeEnum[keyof typeof FeatureTypeEnum];


